<template>
  <nav
    class="navbar navbar-transparent navbar-color-on-scroll fixed-top navbar-expand-lg p-0"
    color-on-scroll="100"
    id="sectionsNav"
  >
    <div class="container">
      <div class="navbar-translate">
        <div
          class="d-flex flex-column justify-content-center align-items-center py-2"
        >
          <img
            src="../../public/assets/images/gtl-logo-with-background.png"
            class="img-fluid"
            style="width:70px"
            alt
          />
          <!-- <div class="text-orange text-center">
                                  <b>Impact Portal</b>
                                </div> -->
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="navbar-toggler-icon" />
          <span class="navbar-toggler-icon" />
          <span class="navbar-toggler-icon" />
        </button>
      </div>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/startup-database"
              >Startup Database</router-link
            >
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/ecosystem"
              ><i class="fa fa-search"
            /></router-link>
          </li>
          <li class="nav-item dropdown text-right" v-if="$store.getters.loggedIn">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">
              <img src="../../public/assets/images/user.png" style="width: 30px" alt="User Image" class="img-size-32 img-circle">
              {{($store.state.userInfo ||{}).name}}
            </a>
            <div class="dropdown-menu dropdown-menu-right">
<!--              <router-link to="/company/dashboard" class="dropdown-item">-->
<!--                Dashboard-->
<!--              </router-link>-->
              <router-link to="/logout" class="dropdown-item">
                Logout
              </router-link>
            </div>
          </li>
  
  
          <li class="nav-item" v-if="!$store.getters.loggedIn">
            <router-link class="nav-link" to="/login"
              ><button class="btn btn-outline-orange bg-white">Login</button></router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
.navbar {
  background: #0599a9 !important;
  color: white !important;
}

.navbar-toggler-icon {
  background-color: white !important;
}
</style>
